module.exports = __webpack_public_path__ + "static/anonine_platforms_reverse-a2a93b0763c435ae4fe7de9615aefdb4.svg";